import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/internal_link.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../services/auth";

const InternalLink = () => {
  const { isEnglish } = useContext(AuthContext);
  const [title, setTitle] = useState({});
  const [Loading, setLoading] = useState(true);

  const fetchAlbum = async () => {
    const AlbumList = await ApiService.getInternalLink();
    const filtred = AlbumList.filter((img) => img.src !== "");
    setTitle(filtred);
    setLoading(false);
  };

  useEffect(() => {
    fetchAlbum();
  }, []);

  if (Loading) {
    return;
  }
  
  return (
    <Container fluid className="p-0 w-100 pt-4">
      <Row className="w-100 p-0 m-0">
        {title.map((lable) => {
          return (
            <Col key={lable.id} md={4} className=" p-0 m-0">
              <Container
                fluid
                className="container_container_link w-100  p-0 m-0 h-100"
              >
                <Link
                  to={lable.link}
                  className="container_img_title_link position-relative overflow-hidden w-100 h-100"
                >
                  <img
                    src={lable.src}
                    alt=""
                    className="w-100 h-100 p-0 m-0 img_container_link object-fit-cover"
                  />
                  <div className="w-100 h-100 position-absolute left-0 top-0 text-center d-flex justify-content-center align-items-center overlay">
                    <h3 className="text-white fs-1 title_link_inside">
                      {isEnglish ? lable.title_eng : lable.title}
                    </h3>
                  </div>
                </Link>
              </Container>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};
export default InternalLink;
